import useStores from './use-stores';
export default function useApolloClient() {
  var _useStores = useStores(),
    apolloClient = _useStores.apolloClient;
  return apolloClient;
}